
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/components/carousel",
      function () {
        return require("private-next-pages/components/carousel.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/components/carousel"])
      });
    }
  